
import React, { Fragment, useState } from 'react'
import { ListGroup } from 'react-bootstrap'

import { useProgrammation } from '@/Hooks/UseProgrammation'
import useTranslation from '@/Hooks/UseTranslation'

import ContentBlock from '../../components/ContentBlock'
import ConstraintCreator from './ConstraintCreator'
import ConstraintEditor from './ConstraintEditor'
import ConstraintItem from './ConstraintItem'

import './Constraints.scss'

const Constraints = () => {

  const { t } = useTranslation()

  const { itemOpened } = useProgrammation()

  const [ constraint, setConstraint ] = useState(null)

  if (itemOpened.type === 'hito' || itemOpened.type === 'reunion') {

    return null
  }

  return (
    <Fragment>
      <ContentBlock
        title={
          t('PROGRAMMATION_MANAGER:SectionConstraintsTitle')
          + ` (${itemOpened.restrictions?.filter((r: any) => r.checked).length} / ${itemOpened.restrictions.length})`
        }
        collapsable
        isCollapsed={itemOpened.restrictions?.filter((r: any) => r.checked).length === itemOpened.restrictions.length}
      >
        <div style={{ textAlign: 'right' }}>
          <ConstraintCreator />
        </div>
        <ListGroup>
          {itemOpened.restrictions.map((r: any, i: number) => (
            <ConstraintItem key={i}
              constraint={r}
              onSelect={() => setConstraint(r)}
            />
          ))}
        </ListGroup>
      </ContentBlock>

      <ConstraintEditor
        constraint={constraint}
        onClose={() => setConstraint(null)}
      />
    </Fragment>
  )
}

export default Constraints
